import type { DateTime } from "luxon";

export class UsuarioResponse {
    id!: number;
    nome!: string;
    cpf!: string;
    generoId!: number;
    email!: string;
    telefone!: string;
    imobiliariaId: number;
    perfilId!: number;
    resetSenhaFlag: boolean;
    arquivoId!: number;
    dataCadastro: DateTime;
    termosAceitos: boolean;
    urlFotoPerfil?: string;
  
    constructor(p: any) {
      this.id = p.id ?? null;
      this.nome = p.nome ?? null;
      this.cpf = p.cpf ?? null;
      this.generoId = p.generoId ?? null;
      this.email = p.email ?? null;
      this.telefone = p.telefone ?? null;
      this.imobiliariaId = p.imobiliariaId ?? null;
      this.perfilId = p.perfilId ?? null;
      this.resetSenhaFlag = p.resetSenhaFlag ?? null;
      this.arquivoId = p.arquivoId ?? null;
      this.dataCadastro = p.dataCadastro ?? null;
      this.termosAceitos = p.termosAceitos ?? false;
      this.urlFotoPerfil = p.urlFotoPerfil ?? null;
    }
  }
  